import ENDPOINT from 'utils/api';
import { handleErrors } from 'utils/error';

class SampleRunService {
  /**
   * 'Constructor' for SampleRunService
   * @param {string} token auth0 token
   */
  constructor(token) {
    this.path = `${ENDPOINT}execute_sample_run`;
    this.requestHeader = {
      headers: {
        'Access-Token': token
      }
    };
    this.jsonRequestHeader = {
      headers: {
        ...this.requestHeader.headers,
        'Content-Type': 'application/json'
      }
    };
  }

  /**
   * Executes single run
   * @async
   * @param {Object} data The data to be sent in the request body
   * @return {Promise} Uploaded file's data
   */
  async samplerun(data) {
    const requestOptions = {
      ...this.jsonRequestHeader,
      method: 'POST',
      body: JSON.stringify(data)
    };
    console.log(requestOptions);
    try {
      const res = await fetch(`${this.path}`, requestOptions);
      if (!res.ok) {
        throw res;
      }
      return await res.json();
    } catch (e) {
      throw await handleErrors(e);
    }
  }
}

export { SampleRunService };
